import { all, takeEvery, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { RequestActionType, requestError, requestSuccess } from '../../actions/requestActions';
import {
    ConfirmResetPassword,
    ConfirmResetPasswordSuccess,
    confirmResetPasswordSuccess,
    ResetPassword,
    ResetPasswordActionType,
} from '../../actions/resetPasswordActions';
import requestPasswordReset, { setNewPassword } from '../../api/resetPassword';
import RequestActions from '../../models/RequestTypes';
import { RequestType } from '../../reducers/requestReducer';
import { toErrorType } from '../isErrorType';
import { redirectWithQuery } from './loginSaga';

type ResetPasswordSaga = Generator<CallEffect<void> | RequestActions, void, void>;
export function* resetPasswordSaga(payload: ResetPassword): ResetPasswordSaga {
    try {
        yield call(requestPasswordReset, payload);
        yield put(requestSuccess(RequestType.ResetPassword, RequestActionType.Success));
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.ResetPassword, RequestActionType.Error));
    }
}

type SetNewPasswordSaga = Generator<
    CallEffect<void> | PutEffect<ConfirmResetPasswordSuccess> | RequestActions,
    void,
    void
>;

export function* setNewPasswordSaga({ payload }: ConfirmResetPassword): SetNewPasswordSaga {
    try {
        yield call(setNewPassword, payload);
        yield put(confirmResetPasswordSuccess(payload.email));
        yield put(requestSuccess(RequestType.ConfirmResetPassword, RequestActionType.Success));
        redirectWithQuery('/login');
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.ConfirmResetPassword, RequestActionType.Error));
    }
}

export default function* (): Generator {
    yield all([
        takeEvery(ResetPasswordActionType.ResetPasswordInit, resetPasswordSaga),
        takeEvery(ResetPasswordActionType.ConfirmResetPasswordInit, setNewPasswordSaga),
    ]);
}
